export const Type={
    ADD_TO_BASKET:'ADD_TO_BASKET',
    REMOVE:'REMOVE',
    REMOVE_FROM_BASKET:'REMOVE_FROM_BASKET',
    SET_USSER:'SET_USE'
}